<script>
import { trackEvent } from '@/src/utils/analytics';

  /*
  * This component is size-customizable so to specify the component height/width you have to
  * bind the class where you've specified the component size to the component the following way:
  *
  * <BaseRedirectButton :class="'your-class-name'"/>
  * */
  export default {
    props: {
      caption: {
        type: String,
        required: true,
      },
      tagName: {
        type: String,
        required: false,
        default: 'a'
      },
      target: {
        type: String,
        required: true
      }
    },
    methods: {
      async handleCheckoutClick() {
        if(sessionStorage.getItem('isAdClick') === 'true') {
          await trackEvent('sponsored_click_buy', {
            event_category: 'google_ads',
          });
        }
        await trackEvent('transfer_to_payment', {
          event_category: 'payment',
        });
      },
    }
  }
</script>

<template>
  <router-link class="base-btn" :tag="tagName" :to="target" @click.native="handleCheckoutClick">{{ caption }}</router-link>
</template>

<style lang="scss" scoped>
  @import '@design';

  .base-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Open Sans Semibold, sans-serif;
    font-weight: 600;
    cursor: pointer;
    color: $white;
    line-height: 35px;
    font-weight: bold;
    font-size: 15px;
    background: $orange;
    box-sizing: border-box;
    border-radius: 5px;
    text-decoration: none;
    text-transform: uppercase;
  }

  .base-btn:hover {
    // transition: background-color $duration-animation-base ease-in-out;
    background: $hover-orange;
  }

</style>
